import { useAtom } from '@reatom/npm-react'

import { ProfilePositionsTableAmountCell } from './profile-positions-table-amount-cell'
import { ProfilePositionsTableCurrencyCell } from './profile-positions-table-currency-cell'
import { ProfilePositionsTablePnlCell } from './profile-positions-table-pnl-cell'

import type { PositionTableColumnId } from '../../positions-table/atoms'
import type {
  AggregatedPositionModel,
  WalletPositionModel,
} from '@root/entities/position'
import type { Column } from '@root/shared/ui-kit'

type Props = {
  value: WalletPositionModel | AggregatedPositionModel
}

const ProfilePositionsTableRemainingCell = ({ value }: Props) => {
  const [positionSizeUsd] = useAtom(value.remainingSizeUsd)

  return (
    <ProfilePositionsTableAmountCell
      amountUsd={positionSizeUsd}
      type="remaining"
    />
  )
}

const ProfilePositionsTableSoldCell = ({ value }: Props) => {
  const [soldSizeUsd] = useAtom(value.soldSizeUsd)

  return <ProfilePositionsTableAmountCell amountUsd={soldSizeUsd} type="sold" />
}

export const ProfilePositionsTableBoughtCell = ({ value }: Props) => {
  const [boughtSizeUsd] = useAtom(value.boughtSizeUsd)

  return (
    <ProfilePositionsTableAmountCell amountUsd={boughtSizeUsd} type="bought" />
  )
}

export const createProfilePositionsTableColumns = () => {
  const profilePositionsTableColumns: Array<
    Column<
      WalletPositionModel | AggregatedPositionModel,
      PositionTableColumnId,
      {
        onOpenWalletPositions?: (value: AggregatedPositionModel) => void
      }
    >
  > = [
    {
      id: 'currency',
      header: ({ t }) => t('token'),
      render: ({ value }) => (
        <ProfilePositionsTableCurrencyCell pair={value.pair} />
      ),
      width: '1.5fr',
      minWidth: 100,
    },
    {
      id: 'bought',
      header: ({ t }) => t('position.invest-short'),
      render: ({ value }) => <ProfilePositionsTableBoughtCell value={value} />,
      minWidth: 30,
      sortable: true,
    },
    {
      id: 'sold',
      header: ({ t }) => t('position.sold-short'),
      render: ({ value }) => <ProfilePositionsTableSoldCell value={value} />,
      minWidth: 30,
      sortable: true,
    },
    {
      id: 'remaining',
      header: ({ t }) => t('position.remaining-short'),
      render: ({ value }) => (
        <ProfilePositionsTableRemainingCell value={value} />
      ),
      minWidth: 30,
      sortable: true,
    },
    {
      id: 'pnl',
      header: ({ t }) => t('common.pnl'),
      render: ({ value }) => <ProfilePositionsTablePnlCell position={value} />,
      minWidth: 30,
      sortable: true,
    },
  ]

  return profilePositionsTableColumns
}
